import React from 'react';

// Fake Data
import dataBox from '../assets/fake-data/data-box';
import dataFaqs from '../assets/fake-data/data-faq';
import dataRoadMap from '../assets/fake-data/data-roadmap';
import dataTestimonials from '../assets/fake-data/data-testimonials';
import dataProject from '../assets/fake-data/dataProject';
import dataTeam from '../assets/fake-data/dataTeam';

// Components
import Banner from '../components/banner/Banner';
import About from '../components/about/About';
import Speciality from '../components/speciality/Speciality';
import Project from '../components/project/Project';
import Roadmap from '../components/roadmap/Roadmap';
import Team from '../components/team/Team';
import Testimonials from '../components/testimonials/Testimonials';
import Faqs from '../components/faqs/Faqs';
import Footer from '../components/footer/Footer';

function Home01() {
    return (
        <div className="home-1 wrapper">

            <Banner />

            <About />

            <Speciality data={dataBox} />

            <Project data={dataProject} />

            <Roadmap data={dataRoadMap} />

            <Team data={dataTeam} />

            <Testimonials data={dataTestimonials} />

            <Faqs data={dataFaqs} />

            <Footer />
        </div>
    );
}

export default Home01;
